<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OT5uIl/tc-custom/9781466873223.jpg?1718183001622" alt="This image is the cover for the book Classical Chinese Poetry"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Classical Chinese Poetry
      </h1>
      <p class="bookDescription body article font2">
        <b>“A magisterial book” of nearly five hundred poems from some of history’s greatest Chinese poets, translated and edited by a renowned poet and scholar (<i>New Republic</i>).</b><br/><br/>The Chinese poetic tradition is the largest and longest continuous tradition in world literature. This rich and far-reaching anthology of nearly five hundred poems provides a comprehensive account of its first three millennia (1500 BCE to 1200 CE), the period during which virtually all its landmark developments took place. <br/><br/>Unlike earlier anthologies of Chinese poetry, Hinton’s book focuses on a relatively small number of poets, providing selections that are large enough to re-create each as a fully realized and unique voice. New introductions to each poet’s work provide a readable history, told for the first time as a series of poetic innovations forged by a series of master poets.<br/><br/><b>“David Hinton has . . . lured into English a new manner of hearing the great poets of that long glory of China’s classical age. His achievement is another echo of the original, and a gift to our language.” —W. S. Merwin</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Hinton
      </h2>
      
      <p class="authorDescription body article"><P>David Hinton's translations of classical Chinese poetry have earned him a Guggenheim fellowship, numerous NEA and NEH fellowships, and both of the major awards given for poetry translation in the United States, the Harold Morton Landon Translation Award, from the Academy of American Poets, and the PEN Award for Poetry in Translation, from the PEN American Center. He is also the first translator in over a century to translate the four seminal works of Chinese philosophy: the <I>Tao Te Ching</I>, <I>Chuang Tzu</I>, <I>Analects</I>, and <I>Mencius</I>. He lives in Vermont.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?079a9f3a